import styled from 'styled-components';

export const Wrapper = styled.div(
  props => `
        display: flex;
        justify-content: center;
        border: 1px solid #efefef;
        widtH: 640px;
        flex-direction : column;
        margin: 0 auto;
        gap: 18px;
        border: 1px solid #efefef;
    `,
);

export const CtaContainer = styled.div(
  props => `
        color: #1f1f1f;
        font-size: 18px;
        line-height: 22px;
        text-align: center;
        gap: 14px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-content: center;
        align-items: center;


        span {
            color: #2f2f2f;
            font-size: 10px;
            line-height: 14px;
        }
    `,
);

export const BookCta = styled.button(
  props => `
        background: linear-gradient(131.54deg,#53b2fe -11.7%,#065af3 158.39%);
        box-shadow: 0px 1px 7px rgba(0,0,0,0.2);
        border-radius: 4px;
        width: 180px;
        outline: 0;
        border: 0;
        cursor: pointer;
        -webkit-align-items: center;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        -webkit-box-pack: center;
        -webkit-justify-content: center;
        -ms-flex-pack: center;
        justify-content: center;
        font-size: 16px;
        font-weight: 900;
        color: #fff;
        font-family: 'Lato';
        //padding-left: 40px;
        //padding-right: 40px;
        border-radius: 26px;
        padding: 12px 40px;
    `,
);

export const MainContainer = styled.div(
  props => `
            //display: flex;
            //justify-content: center;
            //width: 50%;
            //flex-direction: column;
        `,
);

export const Banner = styled.img(
  props => `
        width: 100%;`,
);

export const CalloutDiv = styled.div(
  props => `
        padding: 26px !important;
        margin: 0 10%;
        font-family: Arial, Helvetica, sans-serif;
        //width: 100%;
        background-color: #f8f8f8;
        border: 1px solid #c6c6c6;
        border-collapse: separate;
        padding: 0px;
        border-radius: 8px;
        overflow: hidden;
        display: flex;
        flex-direction: column;
        
        .callout {
            color: #2f2f2f;
            font-size: 18px;
            line-height: 22px;
            text-align: center;
        }

        .boldText {
            font-weight: 900 !important;
        }

        span {
            //padding: 25px 10px 20px;
            color: #2f2f2f;
            font-size: 18px;
            line-height: 22px;
            text-align: center;
            //font-weight: 900;
        }
    `,
);
